const Rwd    = require("../utillity/responsive");
const Utill  = require("../utillity/utill");
const Home   = require('../animation/home');

const Header = require("../dom/header");

module.exports.Bind = function(pjax_active) {
	// pjax_active: true or false

	Utill.LazyLoad();
	
	Rwd.SetInterchange();

	Utill.SetScroll0();

	if ( Utill.IsOriginAnime() ) {

	}else {
		Home.AfterChangeDeco();
	}

};


// WEBPACK FOOTER //
// ./html/_src/js_wb/events/load.js